import { isNil } from '@pct-ts/typeguard';

export function ensureItemsArray<T>(values: T | T[] | null | undefined): T[] {
  if (isNil(values)) {
    return [];
  }
  if (Array.isArray(values)) {
    return values;
  }
  return [values];
}
